<template>
    <div class="childForm">
        <!-- :height="tableHeight" -->
        <el-table @selection-change="handleSelectionChange" :data="formData.nursingRecordsList" :key="randomKey" style="width: 100%">
            <!-- <el-table-column align="center" label="操作" width="90">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-minus" circle @click="del(scope.$index, scope.row)"></el-button>
                </template>
            </el-table-column> -->
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="日期时间" prop="nurseDate" width="160" property="nurseDate">
                <template slot-scope="scope">
                    <div class="nurseDate">
                        <el-date-picker style="width:160px;" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="scope.row.nurseDate" type="datetime"></el-date-picker>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="护理级别" prop="careLevel" width="90" property="careLevel">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.careLevel" placeholder="">
                        <el-option label="①" value="①">特</el-option>
                        <el-option label="②" value="②">Ⅰ</el-option>
                        <el-option label="③" value="③">Ⅱ</el-option>
                        <el-option label="④" value="④">Ⅲ</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="病危/病重" prop="seriouslyIll" width="90" property="seriouslyIll">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.seriouslyIll" placeholder="">
                        <el-option label="①" value="①">无</el-option>
                        <el-option label="②" value="②">病危</el-option>
                        <el-option label="③" value="③">病重</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="意识" prop="awareness" width="90" property="awareness">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.awareness" placeholder="">
                        <el-option label="①" value="①">清醒</el-option>
                        <el-option label="②" value="②">嗜睡</el-option>
                        <el-option label="③" value="③">浅昏迷</el-option>
                        <el-option label="④" value="④">深昏迷</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="体温" align="center">
                <el-table-column align="center" label="℃" prop="centigrade" width="90" property="centigrade">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.centigrade"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="脉搏" align="center">
                <el-table-column align="center" label="次/分" prop="pulse" width="90" property="pulse">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.pulse"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="呼吸" align="center">
                <el-table-column align="center" label="次/分" prop="breathe" width="90" property="breathe">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.breathe"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="血压" align="center">
                <el-table-column align="center" label="mmHg" prop="bloodPressure" width="90" property="bloodPressure">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.bloodPressure"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="疼痛" prop="pain" width="90" property="pain">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.pain" placeholder="">
                        <el-option label="①" value="①">无</el-option>
                        <el-option label="②" value="②">有</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="血氧饱和度" align="center">
                <el-table-column align="center" label="%" prop="bloodOxygen" width="90" property="bloodOxygen">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.bloodOxygen"></el-input>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="吸氧" align="center">
                <el-table-column align="center" label="L/min" prop="oxygenInhalation" width="90" property="oxygenInhalation">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.oxygenInhalation" placeholder="">
                            <el-option label="①" value="①">鼻导管</el-option>
                            <el-option label="②" value="②">面罩</el-option>
                            <el-option label="③" value="③">气管套管</el-option>
                        </el-select>
                    </template></el-table-column>
            </el-table-column>
            <el-table-column label="入量" align="center">
                <el-table-column align="center" label="名称" prop="intakeName" width="90" property="intakeName">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.intakeName" placeholder="">
                            <el-option label="①" value="①">静脉</el-option>
                            <el-option label="②" value="②">口服</el-option>
                            <el-option label="③" value="③">鼻饲</el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="L/min" prop="intakeMl" width="90" property="intakeMl">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.intakeMl"></el-input>
                    </template></el-table-column>
            </el-table-column>
            <el-table-column label="出量" align="center">
                <el-table-column align="center" label="名称" prop="outputName" width="90" property="outputName">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.outputName" placeholder="">
                            <el-option label="①" value="①">尿</el-option>
                            <el-option label="②" value="②">便</el-option>
                            <el-option label="③" value="③">呕吐物</el-option>
                            <el-option label="④" value="④">引流物</el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="ml" prop="outputMl" width="90" property="outputMl">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.outputMl"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="颜色性状" prop="outputColour" width="90" property="outputColour">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.outputColour" placeholder="">
                            <el-option label="①" value="①">正常</el-option>
                            <el-option label="②" value="②">异常</el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="皮肤状况" prop="skinCondition" width="90" property="skinCondition">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.skinCondition" placeholder="">
                        <el-option label="①" value="①">正常</el-option>
                        <el-option label="②" value="②">压疮</el-option>
                        <el-option label="③" value="③">出血点</el-option>
                        <el-option label="④" value="④">破损</el-option>
                        <el-option label="⑤" value="⑤">水肿</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="伤口" prop="wound" width="90" property="wound">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.wound" placeholder="">
                        <el-option label="①" value="①">敷料干燥</el-option>
                        <el-option label="②" value="②">渗出</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="管路护理" prop="pipelineCare" width="90" property="pipelineCare">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.pipelineCare" placeholder="">
                        <el-option label="①" value="①">静脉置管</el-option>
                        <el-option label="②" value="②">导尿管</el-option>
                        <el-option label="③" value="③">氧气管</el-option>
                        <el-option label="④" value="④">胃管</el-option>
                        <el-option label="⑤" value="⑤">引流管</el-option>
                        <el-option label="⑥" value="⑥">气管</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="心理状态" prop="psychology" width="90" property="psychology">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.psychology" placeholder="">
                        <el-option label="①" value="①">正常</el-option>
                        <el-option label="②" value="②">恐惧</el-option>
                        <el-option label="③" value="③">焦虑</el-option>
                        <el-option label="④" value="④">抑郁</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="健康指导" prop="healthGuidance" width="90" property="healthGuidance">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.healthGuidance" placeholder="" multiple>
                        <el-option label="①" value="①">入院</el-option>
                        <el-option label="②" value="②">饮食</el-option>
                        <el-option label="③" value="③">用药</el-option>
                        <el-option label="④" value="④">治疗</el-option>
                        <el-option label="⑤" value="⑤">特殊检查</el-option>
                        <el-option label="⑥" value="⑥">术前</el-option>
                        <el-option label="⑦" value="⑦">术后</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="基础护理" prop="basicNursing" width="90" property="basicNursing">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.basicNursing" placeholder="">
                        <el-option label="①" value="①">晨间护理</el-option>
                        <el-option label="②" value="②">晚间护理</el-option>
                        <el-option label="③" value="③">协助饮食</el-option>
                        <el-option label="④" value="④">卧位护理</el-option>
                        <el-option label="⑤" value="⑤">排泄</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" label="病情观察及措施" prop="diseaseObservation" width="100" property="diseaseObservation">
                <template slot-scope="scope">
                    <el-input type="textarea" autosize v-model="scope.row.diseaseObservation"></el-input>
                </template>
            </el-table-column>
            <el-table-column align="center" label="签名" prop="signature" width="90" property="signature">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.signature"></el-input>
                </template>
            </el-table-column>
        </el-table>
        <div class="addButton">
            <el-button size="small" type="primary" icon="el-icon-plus" circle @click="add"></el-button>
            <el-button size="small" type="danger" icon="el-icon-minus" circle @click="del"></el-button>
        </div>
        <div class="remark">
            <div>
                <div>备注：</div>
                <div>1、护理级别:特、Ⅰ、Ⅱ、Ⅲ</div>
                <div>2、病危病重:①无②病危③病重</div>
                <div>3、意识:①清醒②嗜睡③浅昏迷④深昏迷</div>
                <div>4、疼痛:①无②有</div>
                <div>5、吸氧:①鼻导管②面罩③气管套管</div>
                <div>6、入量:①静脉②口服③鼻饲</div>
                <div>7、出量:①尿②便③呕吐物④引流物</div>
            </div>
            <div style="margin-left:10%;">
                <div style="width:10px;height:21px;"></div>
                <div>颜色性状:①正常②异常</div>
                <div>8、皮肤情况:①正常②压疮③出血点④破损⑤水肿</div>
                <div>9、伤口:①敷料干燥②渗出</div>
                <div>10、管路护理:①静脉置管②导尿管③氧气管④胃管⑤引流管⑥气管</div>
                <div>11、心理状态:①正常②恐惧③焦虑④抑郁</div>
                <div>12、健康指导:①入院②饮食③用药④治疗⑤特殊检查⑥术前⑦术后</div>
                <div>13、基础护理:①晨间护理②晚间护理③协助饮食④卧位护理⑤排泄</div>
            </div>
        </div>
    </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
export default {
    props: ['formData'],
    data() {
        return {
            tableHeight: 600,
            randomKey: Math.random(),
            multipleSelection: [],
        }
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        add() {
            this.formData.nursingRecordsList.push({
                id: '',//主键id（修改的时候用）
                nurseDate: '',//日期时间
                careLevel: '',//护理级别
                seriouslyIll: '',//病危/病重
                bloodPressure: '',//血压
                centigrade: '',//摄氏度
                pulse: '',//脉搏
                breathe: '',//呼吸
                pain: '',//疼痛
                bloodOxygen: '',//血氧饱和度
                oxygenInhalation: '',//吸氧
                intakeName: '',//入量（名称）
                intakeMl: '',//入量（ml）
                outputName: '',//出量（名称）
                outputMl: '',//出量（ml）
                outputColour: '',//出量（颜色性状）
                skinCondition: '',//皮肤情况
                wound: '',//伤口
                pipelineCare: '',//管路护理
                psychology: '',//心理状态
                healthGuidance: '',//健康指导
                basicNursing: '',//基础护理
                diseaseObservation: '',//病情观察及措施
                signature: Lockr.get("skinUserName"),//签名
                awareness: '',//意识
                uuid: uuidv4()
            })
        },
        del() {
            if (this.multipleSelection.length == 0) {
                _g.toast('warning', '请先选择要删除的项目!!!')
                return;
            } else {
                this.formData.nursingRecordsList = this.formData.nursingRecordsList.filter(item => !this.multipleSelection.some(ele => ele.uuid === item.uuid));
            }
            // console.log(this.formData.nursingRecordsList);
            // var index = this.formData.nursingRecordsList.indexOf(row)
            // if (index !== -1) {
            //     this.formData.nursingRecordsList.splice(listIndex, 1)
            // }
        }
    }
}
</script>
<style scoped>
.remark {
  display: flex;
}
.childForm >>> .el-table td,
.el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.childForm >>> .el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.childForm >>> .el-input__inner {
  height: 30px !important;
  line-height: 30px;
  padding: 0 !important;
  box-sizing: border-box;
  border: none;
  text-align: center;
}
.childForm >>> .cell {
  padding: 0 !important;
}
.childForm >>> .el-select__tags {
  overflow: scroll;
  flex-wrap: nowrap;
  max-width: 200px !important;
}
.childForm >>> .el-input__icon {
  display: none;
}
.nurseDate >>> .el-input__icon {
  line-height: 30px !important;
}
.addButton {
  float: right;
}
</style>


